import { TripType } from "../../models/vehicle/trip-type";
import { Driver } from "../driver/driver.model";
import { VehicleType } from "./params/vehicle-type";
import { VehicleConfig } from "./params/vehicle-config";
import { VehicleCapacity } from "./params/vehicle-capacity";
import { VehicleYear } from "./params/vehicle-year";
import { VehicleMake } from "./params/vehicle-make";
import { PayloadType } from "../../models/meta-params/payload-type";
import { VehicleModel } from "./params/vehicle-model";
import { Country } from "../../models/common/country.model";
import { City } from "../../models/common/city.model";
import { TransportationAgency } from "../../company/transportation-agency/transportation-agency.model";

/* eslint-disable */
export class Vehicle {

    vehicleId: number;
    plateNumber: string
    registrationNumber: string;
    engineNumber: string;
    chassisNumber?: string;
    make: VehicleMake;
    model: VehicleModel;
    year: VehicleYear;
    type: VehicleType;
    capacity: VehicleCapacity;
    config: VehicleConfig;
    registrationCountry?: Country;
    registrationCity?: City;
    registrationAuthority?: string;
    registrationIssueDate?: number | Date;
    registrationExpiry: number | undefined;
    registrationUsage?: string;
    registrationImage: string;
    plateSource?: string;
    plateType?: string;
    plateColor?: string;
    ownershipType?: string;
    registeredOwnerName?: string;
    registeredOwnerIdentityNumber?: string;
    vehicleImages?: string[];
    isActive: boolean;
    validated: boolean;
    rating: number;
    tripTypes: TripType[];
    payloadTypes: PayloadType[];
    isInsured: boolean;
    insuranceAmount: number;
    insuranceCompany: any;
    insuranceIssueDate?: number | Date;
    insuranceExpiry: Date;
    insuranceDocumentUrl?: string;
    insurancePolicyNo: string;
    technicalInspectionNumber?: string;
    technicalInspectionIssueDate?: number | Date;
    technicalInspectionExpiryDate?: number | Date;
    technicalInspectionDocumentUrl?: string;
    operatingCardNumber?: string;
    operatingCardIssueDate?: number | Date;
    operatingCardExpiryDate?: number | Date;
    operatingCardCountry?: Country;
    operatingCardActivity?: string;
    operatingCardStatus?: string;
    operatingCardDocumentUrl?: string;
    currentDriver: Driver;
    transportationAgencyId: number
    transportationAgency?: TransportationAgency;
    rentalVendorName?: string;
    rentalStartDate?: number | Date;
    rentalEndDate?: number | Date;
    rentalRateAmount?: number;
    rentalRateCurrency?: string;
    rentalRatePeriod?: string;
    rentalStatus?: string;
    rentalNotes?: string;
    rentalVendorCompanyId?: number;
    rentalContractReferenceNumber?: string;
    rentalDepositAmount?: number;
    rentalDepositCurrency?: string;
    rentalRenewalStatus?: string;
    rentalBillId?: number;
    rentalExpenseId?: number;
    resourceOwnershipType?: string;
    resourceCompanyId?: number;
    resourceCompanyName?: string;
    transporterCrmClientId?: number;
    transporterCrmClientName?: string;
    transporterCrmClientNumber?: string;
    tableRowKey?: string;

}
